import { addTrailingSlashToUrl } from '../../components/common/Route';
import { _i } from '../../utils/_i18n';
import { formatCurrency, formatTaxInfo, getFractionDigits } from '../../utils/formatters';
import { calculateGrossValue } from '../../utils/tax';
import { $ } from '../bootstrap';
import trackQuickPickButtonClicked from '../trackers/helpers';

// Variables
const currency = $('html').attr('data-currency');
const $purchase = $('#purchase');
const maxLines = Number($purchase.attr('data-max-lines'));
const minLines = Number($purchase.attr('data-min-lines'));
const price = $purchase.attr('data-price') / 100;
const nrange = $purchase.freshData('nrange');
const saleTaxPercent = $purchase.freshData('sale_tax_percent');
const saleTaxFixed = $purchase.freshData('sale_tax_fixed');
const padNumbers = $purchase.freshData('pad-numbers');
const $loader = $('.loading');
const $lottery = $("input[name='lottery-display']");
const $raffleNumbers = $('#raffle-numbers');
const showMoreButtonTemplate = $('#raffle-show-more-template').html();
const $quickPick = $('.quick-pick');
const $yourTickets = $('#your-tickets');
const $purchaseSum = $('#purchaseSum');
const $purchaseSumBtn = $('#purchaseSumBtn');
const $purchaseTaxSum = $('#purchaseTaxSum');
const $allNumbers = $('.all-numbers span');
const $evenNumbers = $('.even-numbers span');
const $oddNumbers = $('.odds-numbers span');
const $btnPurchase = $('.btn-purchase');
const $purchaseLineClear = $('.purchase-line-clear');
const $costSummary = $('.cost-summary');
const $jsEnableOnFreeTickets = $('.js-enabled-on-free-tickets');
const $paymentFormLines = $('#paymentFormLines');
const $multiTicketCount = $('#multiTicketCount');

const fractionDigits = getFractionDigits();
const numbersPerGroup = parseInt(process.env.MIX_RAFFLE_NUMBERS_PER_GROUP) || 10000;

const rulesStartNumber = nrange[0];
const rulesEndNumber = nrange[1];
const maxNumber = rulesStartNumber + rulesEndNumber - 1;
const padNumber = maxNumber.toString().length;
const numbersToDisplayLimit = parseInt(process.env.MIX_RAFFLE_DISPLAY_LIMIT || 1999);
const numbersToDisplay = rulesEndNumber > numbersToDisplayLimit ? numbersToDisplayLimit : rulesEndNumber;
let endVisibleRaffleNumber = numbersToDisplay;

let activeRange = {
    from: 1,
    to: numbersPerGroup > rulesEndNumber ? rulesEndNumber : numbersPerGroup
};

const $availableOnlyCheckbox = $("#js-availability-switcher-checkbox");
// show only available ticket numbers
const displayAvailableOnly = () => $availableOnlyCheckbox.prop("checked");

const disableButtons = function () {
    $btnPurchase.prop('disabled', true);
    $purchaseLineClear.prop('disabled', true);
};

let takenNumbersArray = [];
let freeNumbersArray = [];

const numbersCount = {
    free: 0,
    even: 0,
    odd: 0,
};

const ticket = {
    observers: [],
    mode: 'all', // 'all', 'even', 'odd'

    linePrice: price,
    currency,
    totalPrice: 0,

    userLinePrice: price,
    userCurrency: currency,
    userTotalPrice: 0,

    selectedNumbers: [],
    maxLines,
    minLines,
    allNumbersCount: rulesEndNumber,

    disablePicking: false,

    clear() {
        this.deleteAllNumbers();
        $quickPick.prop('disabled', false);
        this.notify('limitOk');
    },

    pickRandomNumbers() {
        const freeNumbersFiltered = this.freeNumbers(this.mode, true);
        const number = freeNumbersFiltered[Math.floor(Math.random() * freeNumbersFiltered.length)];
        this.addNumber(number);
        this.notify('randomPicked', number);

        $quickPick.prop('disabled', !(freeNumbersFiltered.length - 1 > 0));
    },

    createArrayForRange(start, stop) {
        return Array.from({ length: (stop - start) + 1}, (_, i) => start + i);
    },

    freeNumbers(mode = 'all', fromActiveRange = false) {
        let range = [];
        if (fromActiveRange) {
            range = this.createArrayForRange(activeRange.from, activeRange.to + 1);
        } else {
            for (let i = 1; i <= this.allNumbersCount + 1; i++) {
                range.push(i);
            }
        }
        range.pop();

        if (mode === 'even') {
            range = [];
            for (const number of freeNumbersArray) {
                if (number % 2 === 0) {
                    range.push(number);
                }
            }
        } else if (mode === 'odd') {
            range = [];
            for (const number of freeNumbersArray) {
                if (number % 2 !== 0) {
                    range.push(number);
                }
            }
        }

        const occupiedNumbers = [
            ...takenNumbersArray,
            ...this.selectedNumbers
        ];

        const availableNumbers = [];
        for (const number of range) {
            if (!occupiedNumbers.includes(number)) {
                availableNumbers.push(number);
            }
        }

        return availableNumbers;
    },

    evenNumbers() {
        return this.freeNumbers('even');
    },

    oddNumbers() {
        return this.freeNumbers('odd');
    },

    addNumber(number) {
        if (this.disablePicking) {
            return false;
        }

        if (this.numberExists(number)) {
            return false;
        }

        if (this.selectedNumbers.length >= this.maxLines) {
            this.notify('limitExceeded');
            return false;
        }

        this.selectedNumbers.push(number);

        this.recalculatePrice();

        this.notify('add', number);

        return true;
    },

    deleteNumber(number) {
        if (!this.numberExists(number)) {
            return false;
        }
        const index = this.selectedNumbers.indexOf(number);
        this.selectedNumbers.splice(index, 1);
        this.recalculatePrice();
        this.notify("delete", number);
        if (this.selectedNumbers.length < this.maxLines) {
            this.notify("limitOk");
        }
    },

    deleteAllNumbers() {
        const oldNumbers = this.selectedNumbers;
        this.selectedNumbers = [];

        this.recalculatePrice();

        oldNumbers.forEach(number => this.notify('delete', number));
        this.notify('deleteAll');
    },

    numberExists(number) {
        return this.selectedNumbers.filter((f) => f === number).length !== 0;
    },

    recalculatePrice() {
        this.userTotalPrice = this.userLinePrice
            * this.selectedNumbers.length
            * getTicketCount();
        this.notify('ticketChanged');
    },

    subscribe(callback) {
        this.observers.push(callback);
    },

    notify(event, number = null) {
        this.observers.forEach((observer) =>
            observer({
                event,
                number,
                ticket: this,
            })
        );
    },
    markSelectedNumbersAsPicked() {
        this.selectedNumbers.forEach(function (number) {
            $(`[data-number="${number}"]`).addClass('raffle-picked-number');
        });
    },
};

ticket.subscribe((event) => {
    if (event.event === "limitOk") {
        $("#alert-max-numbers-count").addClass("d-none");
        $quickPick.prop('disabled', false);
    }
    if (event.event === "limitExceeded") {
        $("#alert-max-numbers-count").removeClass("d-none");
        $quickPick.prop('disabled', true);
    }
});

// add color
ticket.subscribe((event) => {
    if (event.event === "add") {
        $(`[data-number="${event.number}"]`).addClass("raffle-picked-number");
    }
    if (event.event === "delete") {
        $(`[data-number="${event.number}"]`).removeClass("raffle-picked-number");
    }
});

// widget data
ticket.subscribe((event) => {
    if (event.event === 'ticketChanged') {
        $yourTickets.text(event.ticket.selectedNumbers.length);

        const totalPriceNet = event.ticket.userTotalPrice;
        const totalPriceGross = calculateGrossValue(totalPriceNet, saleTaxPercent, saleTaxFixed);
        const totalPriceTaxSum = totalPriceGross - totalPriceNet;

        $purchaseSum.text(formatCurrency(totalPriceGross, fractionDigits, currency));
        $purchaseSumBtn.text($purchaseSum.text());
        $purchaseTaxSum.text(formatTaxInfo(totalPriceTaxSum, fractionDigits, _i));
        $purchaseSum.freshData('sum', totalPriceGross);
        $purchaseSumBtn.freshData('sum', totalPriceGross);

        const numberTemplate = $('#raffle-selected-number-template').html();
        const $ticketsChosenContainer = $('.raffle-chosen-tickets-container');
        $ticketsChosenContainer.empty();

        ticket.selectedNumbers.forEach((number) => {
            const $number = $(numberTemplate);
            if (padNumbers) {
                $number.text(number.toString().padStart(padNumber, '0'));
            } else {
                $number.text(number);
            }

            $ticketsChosenContainer.append($number);
        });

        $jsEnableOnFreeTickets.attr('disabled', numbersCount.free === 0);
        updateAllEvenOddNumbers();

        const numbers = ticket.selectedNumbers.map(function (obj) {
            return [[obj]];
        });

        $paymentFormLines.val(JSON.stringify(numbers));

        const minimum = numbersCount.free < minLines ? 1 : minLines;
        if (ticket.selectedNumbers.length >= minimum) {
            $btnPurchase.prop('disabled', false);
            $costSummary.removeClass('d-none');
        } else {
            $btnPurchase.prop('disabled', true);
            $costSummary.addClass('d-none');
        }

        $purchaseLineClear.prop('disabled', false);
    }
});

function updateAllEvenOddNumbers() {
    $allNumbers.text(numbersCount.free);
    $evenNumbers.text(numbersCount.even);
    $oddNumbers.text(numbersCount.odd);
}

function getTicketCount() {
    return parseInt($multiTicketCount.val()) || 1;
}

/**
 * @param {number} start
 * @param {number} end
 * @param {boolean} clearNumbers
 * @param {Array<number>} takenNumbers
 */
function generateNumbers(start, end, clearNumbers = true, takenNumbers) {
    if (clearNumbers) {
        $raffleNumbers.empty();
    }

    const template = $('#raffle-number-template').html();

    let addedItemsCount = 0;
    endVisibleRaffleNumber = 0;
    for (let number = start; number <= end; number++) {
        endVisibleRaffleNumber = number;

        if (addedItemsCount === numbersToDisplayLimit || number - 1 === activeRange.to) {
            break;
        }

        const $number = createNumber(number);
        $raffleNumbers.append($number);

        addedItemsCount++;
    }

    if (endVisibleRaffleNumber < activeRange.to) {
        const $showMoreButton = $(showMoreButtonTemplate);
        $raffleNumbers.append($showMoreButton);
    }

    ticket.markSelectedNumbersAsPicked();

    if (displayAvailableOnly()) {
        hideTakenNumbers();
    }

    $loader.slideUp();
    $raffleNumbers.slideDown();

    function createNumber(number) {
        const isNumberAvailable = !takenNumbers.includes(number);
        const $number = $(template);
        $number.attr('data-number', number);

        if (padNumbers) {
            $number.text(number.toString().padStart(padNumber, '0'));
        } else {
            $number.text(number);
        }

        if (!isNumberAvailable) {
            $number.addClass('raffle-taken-number');
        }

        return $number;
    }
}

function generateGroupsButtons() {
    const $raffleButtonsContainer = $('.raffle-group-buttons-container');
    const template = $('#raffle-group-button-template').html();

    // TODO: we should display 5 group buttons before and after actual button
    const numberOfButtons = Math.round(rulesEndNumber / numbersPerGroup);
    let lastRange = activeRange.from;
    let currentRange = numbersPerGroup;
    const $buttons = $();

    if (numberOfButtons > 1) {
        for (let i = 1; i <= numberOfButtons; i++) {
            const $button = $(template);
            $button
                .attr('data-range-from', lastRange)
                .attr('data-range-to', currentRange)
                .text(`${lastRange} - ${currentRange}`);

            lastRange = currentRange + 1;
            currentRange += numbersPerGroup;
            // Prevent getting out of range
            if (currentRange > rulesEndNumber) {
                currentRange = rulesEndNumber;
            }

            $raffleButtonsContainer.append($button);

            $buttons.push($button.get(0));
        }

        $raffleButtonsContainer.removeClass('d-none');

        $buttons.on('click', function () {
            if (this.classList.contains('active')) {
                return;
            }

            $buttons.removeClass('active');
            this.classList.add('active');

            activeRange.from = parseInt(this.dataset.rangeFrom);
            activeRange.to = parseInt(this.dataset.rangeTo);

            showNumbersButtons(activeRange.from, activeRange.to);
        });

        $buttons.not(':disabled').get(0).click();
    } else {
        showNumbersButtons(activeRange.from, activeRange.to);
    }

    /**
     * @param {number} rangeFrom
     * @param {number} rangeTo
     */
    function showNumbersButtons(rangeFrom, rangeTo) {
        $loader.slideDown();
        $raffleNumbers.slideUp(function () {
            // reset counter
            endVisibleRaffleNumber = 0;
            loadNumbers(
                rangeFrom,
                rangeTo,
                function (data) {
                    takenNumbersArray = data.range.takenNumbers;
                    freeNumbersArray = data.range.freeNumbers;

                    numbersCount.free = data.total.freeNumbersCount;
                    numbersCount.even = data.total.evenCount;
                    numbersCount.odd = data.total.oddCount;

                    updateAllEvenOddNumbers();

                    generateNumbers(rangeFrom, rangeTo, true, takenNumbersArray);
                    $quickPick.prop('disabled', data.range.freeNumbers.length === 0);
                },
                loadNumbersErrorCallback
            );
        });

        $raffleNumbers.scrollTop(0);
    }
}

function selectOldNumbers() {
    const oldLines = JSON.parse($purchase.attr('data-old-lines') ?? '[]');
    oldLines.forEach((line) => {
        ticket.addNumber(line[0][0]);
    });
}

function hideTakenNumbers() {
    $(".raffle-taken-number").addClass("d-none");
}

function showTakenNumbers() {
    $(".raffle-taken-number").removeClass("d-none");
}

$(document).on("click", ".raffle-number:not(.raffle-taken-number)", (event) => {
    const number = $(event.target).data("number");
    if (!ticket.numberExists(number)) {
        ticket.addNumber(number);

        const freeNumbersFiltered = ticket.freeNumbers(ticket.mode, true);
        $quickPick.prop('disabled', !(freeNumbersFiltered.length) > 0);
    } else {
        ticket.deleteNumber(number);
    }
});

$purchaseLineClear.click((e) => {
    e.preventDefault();
    ticket.clear();
});

$quickPick.click((e) => {
    e.preventDefault();
    ticket.pickRandomNumbers();
    trackQuickPickButtonClicked($lottery.val());
});

$('#paymentForm').on('submit', function(e) {
    if (!checkPromoCodeField()) {
        e.preventDefault();
        return;
    }
    ticket.disablePicking = true;
    disableButtons();
});

$availableOnlyCheckbox.on('click', function(event) {
    if ($(event.target).is(":checked")) {
        hideTakenNumbers();
    } else {
        showTakenNumbers();
    }

    $('.raffle-filter-button.active').click();
});

$(document).on('click', '#raffle-show-more', function(e) {
    e.preventDefault();

    let maxRange = activeRange.to - endVisibleRaffleNumber;
    if (maxRange > numbersToDisplayLimit) {
        maxRange = endVisibleRaffleNumber + numbersToDisplayLimit;
    } else {
        maxRange = activeRange.to;
    }

    generateNumbers(endVisibleRaffleNumber, maxRange, false, takenNumbersArray);
    this.remove();
});

// Raffle All/Even/Odd filters
const $raffleFilterButtons = $('.raffle-filter-button');
$raffleFilterButtons.on('click', function (e) {
    e.preventDefault();

    const $allRaffleNumbers = $('.raffle-number');

    $raffleFilterButtons.removeClass('active');
    this.classList.add('active');

    if (this.classList.contains('odds-numbers')) {
        ticket.mode = 'odd';
    } else if (this.classList.contains('even-numbers')) {
        ticket.mode = 'even';
    } else {
        ticket.mode = 'all';
    }

    let $itemsToHide;
    let $itemsToShow;
    switch (ticket.mode) {
        case 'all':
            $itemsToHide = $allRaffleNumbers;
            break;

        case 'even':
            // NOTE: Is it working correctly? it's checking position in list of value?
            // this is working ok only because wa are rendering all buttons sorted anyway...
            $itemsToHide = $allRaffleNumbers.odd();
            $itemsToShow = $allRaffleNumbers.even();
            break;

        case 'odd':
            $itemsToHide = $allRaffleNumbers.even();
            $itemsToShow = $allRaffleNumbers.odd();
            break;
    }

    if (displayAvailableOnly()) {
        if ($itemsToHide) {
            $itemsToHide = $itemsToHide.not('.raffle-taken-number');
        }
        if ($itemsToShow) {
            $itemsToShow = $itemsToShow.not('.raffle-taken-number');
        }
    }

    if ($itemsToHide) {
        $itemsToHide.removeClass('d-none');
    }

    if ($itemsToShow) {
        $itemsToShow.addClass('d-none');
    }
});

$multiTicketCount.change(function () {
    ticket.recalculatePrice();
});

let loadNumbersRequest = null;
function loadNumbers(rangeFrom, rangeTo, callbackSuccess, callbackError) {
    if (!$lottery.length) {
        return;
    }

    const lotterySlug = $lottery.val();

    if (loadNumbersRequest !== null) {
        loadNumbersRequest.abort();
        loadNumbersRequest = null;
    }

    loadNumbersRequest = $.ajax({
        type: 'GET',
        url: addTrailingSlashToUrl(`/site/api/play/${lotterySlug}/raffle-numbers`),
        dataType: 'json',
        data: {
            rangeFrom,
            rangeTo,
        },
        success: callbackSuccess,
        error($xhr, status, error) {
            if (status !== 'abort') {
                callbackError(status, error);
            }
        },
    });
}

function initPromoCodes() {
    const $promoCode = $('#promo-code');

    if (!$promoCode.length) {
        return;
    }

    function checkDiscount() {
        const discountAmount = $purchaseSum.freshData('discount_amount');
        const discountType = $purchaseSum.freshData('discount_type');

        if (!(discountAmount && discountType)) {
            return;
        }

        let discountedPrice = 0;
        const originalPrice = ticket.userTotalPrice;
        if (discountType === 'percentage_discount') {
            discountedPrice = ticket.userTotalPrice - ticket.userTotalPrice * (discountAmount / 100);
        } else if (discountType === 'amount_discount') {
            discountedPrice = ticket.userTotalPrice - discountAmount;
        }

        const originalPriceGross = calculateGrossValue(originalPrice, saleTaxPercent, saleTaxFixed);

        const finalPriceNet = discountedPrice < 0 ? 0 : discountedPrice;
        const finalPriceGross = calculateGrossValue(finalPriceNet, saleTaxPercent, saleTaxFixed);
        const finalPriceTaxSum = finalPriceGross - finalPriceNet;

        $purchaseSum.freshData('sum', finalPriceGross);
        $purchaseSumBtn.freshData('sum', finalPriceGross);

        const finalPriceFormatted = formatCurrency(finalPriceGross, fractionDigits, currency);

        if (originalPrice > 0) {
            $purchaseSum.html(
                `<s class="old-price">${formatCurrency(
                    originalPriceGross,
                    fractionDigits,
                    currency
                )}</s> ${finalPriceFormatted}`
            );
            $purchaseSumBtn.html($purchaseSum.html());
        } else {
            $purchaseSum.text(finalPriceFormatted);
            $purchaseSumBtn.text($purchaseSum.text());
        }

        $purchaseSumBtn.html($purchaseSum.html());
        $purchaseTaxSum.text(formatTaxInfo(finalPriceTaxSum, fractionDigits, _i));
    }

    function createRemoveEvent() {
        const $promoCodeRemove = $('.promo-code-remove');
        if ($promoCodeRemove.length > 0) {
            $promoCodeRemove.on('click', function () {
                const totalPriceNet = ticket.userTotalPrice;
                const totalPriceGross = calculateGrossValue(totalPriceNet, saleTaxPercent, saleTaxFixed);
                const totalPriceTaxSum = totalPriceGross - totalPriceNet;

                $purchaseSum.text(formatCurrency(totalPriceGross, fractionDigits, currency));
                $purchaseSumBtn.text($purchaseSum.text());
                $purchaseTaxSum.text(formatTaxInfo(totalPriceTaxSum, fractionDigits, _i));
            });
        }
    }

    ticket.subscribe(function (event) {
        if (event.event === 'ticketChanged') {
            checkDiscount();
            createRemoveEvent();
        }
    });

    if ($btnPurchase) {
        $btnPurchase.on('discountChanged', () => {
            checkDiscount();
            createRemoveEvent();
        });
    }
}

function loadNumbersErrorCallback(status, error) {
    $('#raffle-not-available-alert').removeClass('d-none');
    $('.raffle').addClass('d-none');
    console.warn('An error occurred while fetching data for raffle', status, error);
}

function init() {
    generateGroupsButtons();
    ticket.notify('ticketChanged');
    selectOldNumbers();
    // hideTakenNumbers();
    // ticket.recalculatePrice();
    initPromoCodes();
}

init();
